export const GET_ASSIGNED_APPOINTMENTS = "GET_ASSIGNED_APPOINTMENTS";
export const GET_CONFIRMED_APPOINTMENTS = "GET_CONFIRMED_APPOINTMENTS";
export const CONFIRM_APPOINTMENT = "CONFIRM_APPOINTMENT";
export const RESCHEDULE_APPOINTMENT = "RESCHEDULE_APPOINTMENT";
export const MOVE_BACK_QUEUE = "MOVE_BACK_QUEUE";
export const GET_AVAILABLE_SLOTS = "GET_AVAILABLE_SLOTS";
export const DOCTOR_ASSIGN = "DOCTOR_ASSIGN";
export const REMOVE_APPOINTMENT = "REMOVE_APPOINTMENT";
